import React from 'react';
import { t } from '../../../../Utils/CommonUtils/translate';
import { images } from '../../../../Constants/ImageUrls';
import { BabyGenderSec } from './styled';

export default function BabyGender(props) {
  const { choosenGender } = props;
  const setChoosen = (value) => {
    choosenGender.current = value;
  };
  return (
    <BabyGenderSec>
      <div className="flex">
        <img
          src={images.babyGirlGender}
          alt="baby girl"
          htmlFor={'Girl'}
          loading="lazy"
          className="genderImage"
          onClick={() => {
            document.getElementById('Girl').click();
          }}
        />
        <div>
          <input
            type="radio"
            name="gender"
            id="Girl"
            onChange={() => setChoosen('Girl')}
          />
          <label htmlFor={'Girl'}>{t('Baby Girl')}</label>
        </div>
      </div>
      <div className="flex">
        <img
          src={images.babyBoyGender}
          alt="baby boy"
          htmlFor={'Boy'}
          className="genderImage"
          loading="lazy"
          onClick={() => {
            document.getElementById('Boy').click();
          }}
        />
        <div>
          <input
            type="radio"
            name="gender"
            id="Boy"
            onChange={() => setChoosen('Boy')}
          />
          <label htmlFor={'Boy'}>Baby Boy</label>
        </div>
      </div>

      <div className="flex">
        <img
          src="/images/bothbaby.svg"
          alt="both"
          htmlFor={'both'}
          loading="lazy"
          className="genderImage"
          onClick={() => {
            document.getElementById('both').click();
          }}
        />
        <div>
          <input type="radio" name="gender" id="both" defaultChecked={true} />
          <label htmlFor={'both'} onChange={() => setChoosen(null)}>
            Both
          </label>
        </div>
      </div>
    </BabyGenderSec>
  );
}
